import { LeadSignInStatsGtmLabelEnum } from 'common/module/lead/sign-in/stats/gtm/label.enum';
import { LeadSignInTemplate } from 'common/module/lead/sign-in/template';
import { LeadSignInTemplatePropsInterface } from 'common/module/lead/sign-in/template-props.interface';
import { LeadSignInViewStore } from 'common/module/lead/sign-in/view-store';
import { LeadSignInViewStoreFactory } from 'common/module/lead/sign-in/view-store.factory';
import { preactConnectStore } from 'common/module/preact/connect-store';
import { StatsTealiumDataLayerEventReferenceEnum } from 'common/module/stats/tealium/data-layer/event-reference.enum';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

export const LeadEmailSignInComponent = preactConnectStore<
  LeadSignInViewStore,
  LeadSignInTemplatePropsInterface,
  {
    isNotNowButtonHidden?: boolean;
  }
>(
  LeadSignInViewStoreFactory,
  (store, { props }) => ({
    ...store.getState(),
    isNotNowButtonHidden: props.isNotNowButtonHidden,
    isVisible: !UserAuthenticationService().getToken(),
  }),

  (store) => {
    store.setEventReference(StatsTealiumDataLayerEventReferenceEnum.EMAIL_LEAD);
    store.initialize({
      gtmLabel: LeadSignInStatsGtmLabelEnum.postEmailLead,
    });
  }
)(LeadSignInTemplate);
